import {useQuery} from '@tanstack/react-query';
import { authorizedGet } from '../functions/AuthService';

export const usePlantReport = (fecha, enabled = true) => {
    return useQuery({
        queryKey: ['plantReport', fecha],
        enabled,
        queryFn: async () => {
            const response = await authorizedGet("/jobtrack/getplantreport", {fecha});
            const resData = await response.body.json();
            // console.log("Data: ", resData);
            return resData;
        },
        staleTime: 1000 * 60 * 5, //5 minutes
        gcTime: 1000 * 60 * 15, //Keep it in memory for 15 minutes
        refetchOnWindowFocus: false //Prevent refresh if the tab is clicked
    });
}

export const useMachineEfficiency = (enabled = true) => {
    return useQuery({
        queryKey: ['plantReport', 'machineEfficiency'],
        enabled,
        queryFn: async () => {
            const response = await authorizedGet("/jobtrack/getmachineefficiency");
            const resData = await response.body.json();
            // console.log("Data: ", resData);
            return resData;
        },
        staleTime: 1000 * 60 * 5, //5 minutes
        gcTime: 1000 * 60 * 15, //Keep it in memory for 15 minutes
        refetchOnWindowFocus: false //Prevent refresh if the tab is clicked
    });
}